import { createAction } from 'redux-actions';
import { authFetch } from '../AuthFetch';

export const changeOrderValue = createAction('CHANGE_ORDER_VALUE');

export const findAllGears = () => (
  (dispatch) => {
    let url = '/firefighter/common/gears';
    authFetch('GET', url, null, (json) => {
      dispatch({
        type: 'FIND_ALL_GEARS',
        payload: json
      });
    });
  }
);

export const findAllOrderIds = () => (
  (dispatch) => {
    let url = '/firefighter/orders/orderIds';
    authFetch('GET', url, null, (json) => {
      dispatch({
        type: 'FIND_ALL_ORDERIDS',
        payload: json
      });
    });
  }
);

export const findOrderList = (pagingData, serachData) => (
  (dispatch) => {

    let searchDataUrl = '';
    if (serachData != null) {
      searchDataUrl = '&searchKeys=';
      for (let i = 0; i < serachData.searchKeys.length; i++) {
        searchDataUrl += serachData.searchKeys[i] + ',';
      }
      searchDataUrl += '&searchWord=' + serachData.searchWord;
    }

    let url = '/firefighter/orders?activePage=' + pagingData.activePage + '&itemPerPage=' + pagingData.itemPerPage + searchDataUrl;
    authFetch('GET', url, null, (json) => {
      dispatch({
        type: 'FIND_ORDER_LIST',
        payload: json
      });
    });
  }
);

export const findOrderDetailList = (payload) => (
  (dispatch) => {
    let url = '/firefighter/orders/' + payload.orderId + '/orderDetails';
    authFetch('GET', url, null, (json) => {
      dispatch({
        type: 'FIND_ORDER_DETAIL_LIST',
        payload: json
      });
    });
  }
);

export const addOrder = (order, pagingData) => (
  (dispatch) => {
    let url = '/firefighter/orders';
    authFetch('POST', url, JSON.stringify(order), (json) => {
      dispatch({
        type: 'ADD_ORDER',
        payload: json
      });
      dispatch(findAllOrderIds());
      dispatch(findOrderList(pagingData));
    });
  }
);

export const editOrder = (order, pagingData) => (
  (dispatch) => {
    let url = '/firefighter/orders/' + order.get('orderId');
    authFetch('PUT', url, JSON.stringify(order), (json) => {
      dispatch({
        type: 'EDIT_ORDER',
        payload: json
      });
      dispatch(findOrderList(pagingData));
    });
  }
);

export const findOrder = (pk) => (
  (dispatch) => {
    let url = '/firefighter/orders/' + pk.order_id;
    authFetch('GET', url, null, (json) => {
      dispatch({
        type: 'FIND_ORDER',
        payload: json
      });
    });
  }
);

export const changeOrderDetailValue = createAction('CHANGE_ORDER_DETAIL_VALUE');

export const addOrderDetail = (orderDetail) => (
  (dispatch) => {
    let url = '/firefighter/orders/' + orderDetail.orderId + '/orderDetails';
    authFetch('POST', url, JSON.stringify(orderDetail), (json) => {
      dispatch({
        type: 'ADD_ORDER_DETAIL',
        payload: json
      });
      dispatch(findOrderDetailList({ orderId: orderDetail.get('orderId') }));
    });
  }
);

export const editOrderDetail = createAction('EDIT_ORDER_DETAIL');

export const deleteOrder = (deleteKey, pagingData) => (
  (dispatch) => {
    let url = '/firefighter/orders';
    authFetch('DELETE', url, JSON.stringify(deleteKey), (json) => {
      dispatch({
        type: 'DELETE_ORDER',
        payload: json
      });
      dispatch(findAllOrderIds());
      dispatch(findOrderList(pagingData));
    });
  }
);

export const deleteOrderDetail = (deleteKey) => (
  (dispatch) => {
    let url = '/firefighter/orders/' + deleteKey.order_id + '/orderDetails/' + deleteKey.order_detail_id;
    authFetch('DELETE', url, null, (json) => {
      dispatch({
        type: 'DELETE_ORDER_DETAIL',
        payload: json
      });
      dispatch(findOrderDetailList({ orderId: deleteKey.order_id }));
    });
  }
);

export const findOrderDetail = (pk) => (
  (dispatch) => {
    let url = '/firefighter/orders/' + pk.order_id + '/orderDetails/' + pk.order_detail_id;
    authFetch('GET', url, null, (json) => {
      dispatch({
        type: 'FIND_ORDER_DETAIL',
        payload: json
      });
    });
  }
);

export const changeOrderActivePage = createAction('CHANGE_CUSTOMER_ACTIVE_PAGE');

export const openAddOrderModal = createAction('OPEN_ADD_ORDER_MODAL');
export const openEditOrderModal = createAction('OPEN_EDIT_ORDER_MODAL');
export const openEditOrderDetailModal = createAction('OPEN_EDIT_ORDER_DETAIL_MODAL');
export const openViewOrderModal = createAction('OPEN_VIEW_ORDER_MODAL');
export const closeOrderModal = createAction('CLOSE_ORDER_MODAL');
// export const changeShowSpecIdHasLabel = createAction('CHANGE_SHOW_SPECIDHASLABEL');

export const changeShowSpecIdHasLabel = (payload) => (
  (dispatch) => {
    let url = '/firefighter/common/gearHasLabel/' + payload.gear_name;
    authFetch('GET', url, null, (json) => {
      dispatch({
        type: 'CHANGE_SHOW_SPECIDHASLABEL',
        payload: json
      });
    });
  }
);


// WEBPACK FOOTER //
// ./src/actions/orderActions.js